"use strict";

(function (Drupal) {
  Drupal.behaviors.instagram_feed = {
    attach: function attach(context, settings) {
      var gallery = context.querySelector('.instagram-feed__results .view-content');
      if (!gallery) {
        return;
      }

      // dragging helpers
      var galleryIsDragging = function galleryIsDragging() {
        wrap.classList.add('is-dragging');
      };
      var galleryIsStopped = function galleryIsStopped() {
        wrap.classList.remove('is-dragging');
      };

      // init
      var instagram = tns({
        container: gallery,
        items: 1,
        slideBy: 'page',
        fixedWidth: 400,
        autoHeight: true,
        gutter: 18,
        speed: 600,
        center: true,
        arrowKeys: true,
        autoplay: false,
        mouseDrag: true,
        controls: false,
        edgePadding: 100,
        nav: false,
        observer: true,
        lazyLoad: false,
        viewportMax: 2100,
        responsive: {
          300: {
            fixedWidth: 300,
            gutter: 10,
            items: 1,
            edgePadding: 80
          },
          600: {
            gutter: 10,
            items: 1,
            center: true,
            edgePadding: 150
          },
          1200: {
            gutter: 18,
            items: 1,
            center: true,
            edgePadding: 200
          }
        }
      });
      if (!instagram) {
        console.error('Tiny Slider initialization failed.');
        return;
      } else {
        console.log(instagram.getInfo());
      }

      // watch for a11y class and destroy slider for easy navigation
      function sliderDestroy(mutationsList, observer) {
        mutationsList.forEach(function (_ref) {
          var attributeName = _ref.attributeName;
          if (attributeName === 'class' && document.body.classList.contains('is-a11y')) {
            instagram.destroy();
            instagramObserve.disconnect();
          }
        });
      }

      // observer
      var instagramObserve = new MutationObserver(sliderDestroy);
      instagramObserve.observe(document.body, {
        attributes: true
      });

      // events
      instagram.events.on('dragMove', galleryIsDragging);
      instagram.events.on('dragEnd', galleryIsStopped);
    }
  };
})(Drupal);